import ApricotHeader from 'components/Generics/Header/ApricotHeader';
import Footer from 'components/Generics/Footer/Footer';
import React from 'react';
import * as S from 'components/AuthError/AuthError.style';
import AuthErrorMsg from 'components/AuthError/AuthErrorMsg';
import { IAuthErrorMessage } from './AuthErrorMsg';

const ApricotAuthError = (props: IAuthErrorMessage): React.ReactElement => {

    return (
        <S.Background>
            <S.ApricotBackground>
                <ApricotHeader />
                <AuthErrorMsg {...props} />
                <Footer />
            </S.ApricotBackground>
        </S.Background>
    );
};

export default ApricotAuthError;
